import React from 'react';
import { Link } from 'react-router-dom';

import { COPIES } from '../../../../constants';

const CareersAtFiverrLink = () => (
    <Link to="/" className="nav-link">
        {COPIES.careersAtFiverr}
    </Link>
);

export default CareersAtFiverrLink;
